<ds-input
  id="accessibility-conformance-level"
  [label]="'accessibility_standard_title_case' | translate"
  [required]="required"
  [errorState]="errorState"
  [errorMessage]="errorMessage"
>
  <select
    ds-input-field
    class="mw-100"
    [disabled]="disabled"
    id="accessibility-conformance-level-selector"
    (change)="onConformanceLevelChange($event)"
  >
    @for (level of a11yStandards$ | async; track $index) {
      <option [value]="level" [selected]="level === conformanceLevel">
        {{ level | translate }}
      </option>
    }
  </select>
</ds-input>
